// extracted by mini-css-extract-plugin
export default {"avatar":"SearchResult_avatar__1S9vx","details":"SearchResult_details__+MaTY","highlight":"SearchResult_highlight__UUyYC","name":"SearchResult_name__QWirP"};